<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="show" max-width="500px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card v-if="!!payment_info && addOn">
        <v-card-title>
          <h2>Cancel {{ addOn.name }}?</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0 text-xs-left">

          <div class="mt-2" >
            <span>You will continue to have access to {{ addOn.name }} premium content until your next billing cycle. Your subscription will not be renewed.</span>
          </div>

          <v-layout justify-center wrap class="mt-3">
            <v-btn round color="primary" @click="submitAddOnCancel">Cancel Subscription</v-btn>
          </v-layout>

        </v-card-text>

      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import api from "../../../services/api_endpoints"
  import store from "../../../store"
  import LoadingDialog from "../../LoadingDialog"

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      payment_info: store.state.ccInfo,
      snackbar: {
        success: false,
        error: false,
        timeout: 2000,
        errorMessage: "An unknown error occurred",
        successMessage: "Add-on successfully removed"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      onClose: {
        type: Function,
        default: ()=> ({})
      },
      addOn: {
        type: Object,
        default: () => ({
          id: 0,
          name: '',
          price: 0,
          monthly: 0,
          description: ''
        })
      },
    },
    mounted() {
      // subscribe to changes on the 'setUser' store mutation
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setCcInfo') {
          this.payment_info = state.ccInfo
        }
      })
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async submitAddOnCancel() {

        this.showLoadingDialog = true;
        let response = await api.submitAddOnCancel(this.addOn.id);
        this.showLoadingDialog = false;

        if (response.success) {
          this.snackbar.success = true;
          this.show = false
        } else {
          this.snackbar.error = true
        }
        if (this.isFunction(this.onClose)) this.onClose(response.success)
      },
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
